export const SNAP_ORIGIN = 'npm:@metamask/message-signing-snap';
/**
 * Requests Connection to the Message Signing Snap
 *
 * @param provider - MetaMask Wallet Provider
 * @returns snap connect result
 */
export async function connectSnap(provider) {
    const result = await provider.request({
        method: 'wallet_requestSnaps',
        params: {
            [SNAP_ORIGIN]: {},
        },
    });
    return result;
}
/**
 * Gets Snaps from a MetaMask Wallet
 *
 * @param provider - MetaMask Wallet Provider
 * @returns All currently installed snaps.
 */
export async function getSnaps(provider) {
    const result = await provider.request({
        method: 'wallet_getSnaps',
    });
    return result;
}
/**
 * Check if snap is connected
 *
 * @param provider - MetaMask Wallet Provider
 * @returns if snap is connected
 */
export async function isSnapConnected(provider) {
    try {
        const snaps = await getSnaps(provider);
        if (!snaps) {
            return false;
        }
        return Object.keys(snaps).includes(SNAP_ORIGIN);
    }
    catch (e) {
        console.error('Failed to determine if snap is connected', e);
        return false;
    }
}
export const MESSAGE_SIGNING_SNAP = {
    async getPublicKey(provider) {
        const publicKey = await provider.request({
            method: 'wallet_invokeSnap',
            params: { snapId: SNAP_ORIGIN, request: { method: 'getPublicKey' } },
        });
        return publicKey;
    },
    async signMessage(provider, message) {
        const signedMessage = await provider?.request({
            method: 'wallet_invokeSnap',
            params: {
                snapId: SNAP_ORIGIN,
                request: { method: 'signMessage', params: { message } },
            },
        });
        return signedMessage;
    },
};
//# sourceMappingURL=messaging-signing-snap-requests.mjs.map